export const excludedFields = [
  "receiving_report_number",
  "outbound_summary",
  "created_at",
  "updated_at",
  "rack_locations",
  "available_quantity",
  "in_cart_quantity",
  "reserved_quantity",
  "warehouse_quantity",
  "allocated_quantity",
  "last_in",
  "last_out",
];
